<div [hidden]="!displayed" class="custom-markup-container" #contentWrapper></div>
